export default __webpack_public_path__ + "static/post-quantum-cryptography-dati-qubit-crittografia-099bec20b34abfb4a39ba452e779ba45.png";